var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationErrorColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18.5,
    viewBox: "0 0 16 18.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28357",
    "data-name": "Group 28357",
    transform: "translate(-1194 -172.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Color",
    "data-name": " \\u21B3Color",
    d: "M7,16.5a1.539,1.539,0,0,1-1.548-1.527h3.1A1.539,1.539,0,0,1,7,16.5Zm7-2.3H0V13.43L1.555,11.9v-4.6A5.331,5.331,0,0,1,2.778,3.9,5.46,5.46,0,0,1,5.833,2.049v-.9a1.167,1.167,0,0,1,2.334,0v.9A5.461,5.461,0,0,1,11.222,3.9a5.331,5.331,0,0,1,1.223,3.39v4.6L14,13.43V14.2Zm-7.778-4.6v1.535H7.778V9.593H6.222Zm0-4.6v3.07H7.778V4.988H6.222Z",
    transform: "translate(1194 174.864)",
    fill: "#024D82"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28356",
    "data-name": "Group 28356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_209",
    "data-name": "Ellipse 209",
    transform: "translate(1199 173.864)",
    fill: "#e95f47",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Color-2",
    "data-name": " \\u21B3Color",
    d: "M3.735.376,3.359,0,1.867,1.491.376,0,0,.376,1.491,1.867,0,3.359l.376.376L1.867,2.244,3.359,3.735l.376-.376L2.244,1.867Z",
    transform: "translate(1202.133 176.996)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationErrorColor);
export default __webpack_public_path__ + "static/media/notification-error-color.b9e39b3a76c075786f140be4638e2bd2.svg";
export { ForwardRef as ReactComponent };